export default {
	unreadMessagesAlertId: 'UNREAD_MESSAGES',
	connectingAgentAlertId: 'CONNECTING_AGENT',
	livechatConnectedAlertId: 'LIVECHAT_CONNECTED',
	livechatDisconnectedAlertId: 'LIVECHAT_DISCONNECTED',
	livechatQueueMessageId: 'LIVECHAT_QUEUE_MESSAGE',
};
